import React, { Component } from 'react'
import format from 'date-fns/format'
import koLocale from 'date-fns/locale/ko'
import './index.css'

class ChatRoom extends Component {
  constructor(props) {
    super(props)
    this.messageInput = React.createRef()
  }

  componentDidMount() {
    this.props.onLoad()
  }

  formatDate(isoString) {
    return format(new Date(isoString), 'yyyy년 M월 dd일 HH시 mm분 ss초', { locale: koLocale })
  }

  onAdd() {
    this.props.onAddButtonClick(this.messageInput.current.value, this.props.chat.id)
  }

  render() {
    if (this.props.isLoading) {
      return <div>Loading...</div>
    }

    return (
      <div className="chat-room">
        <ul>
          {
            this.props.chat && this.props.chat.messages.map(msg => {
              return (
                <li key={msg.id} style={{ margin: '20px' }}>
                  {msg.user_id === this.props.chat.partner.id ? this.props.chat.partner.name : 'me' }: {msg.text}<br /> ({ this.formatDate(msg.created_at) })
                </li>
              )
            })
          }
        </ul>
        <input type="text" ref={this.messageInput} />
        <button onClick={this.onAdd.bind(this)}>Add</button>
      </div>
    )
  }
}

export default ChatRoom
